<template>
  <div :class="['checkbox', 'tip', generateCheckboxClass(field)]"
       :data-original-title="field.help"
       data-placement="bottom"
       data-toggle="tooltip">
          <input type="checkbox"
                  @click="updateFromCheckbox"
                  :checked="current_value"
                  :data-idx="field_idx"
                  :id="'checkbox'+field_idx">
        <label :for="'checkbox'+field_idx">{{field.label}}</label>
    </div>
</template>

<script>
export default {
  name:"CustomCheckbox",
  props:[
    "field",
    "value",
    "field_idx",
    "as_number"
  ],
  data(){
    return {
        current_value:Boolean(this.value)
    }
  },
  methods:{
    updateFromCheckbox(){
      this.current_value = !this.current_value
      this.$emit("field-updated", {type:this.field.type, idx:this.field_idx, new_value:this.as_number == true ? (Number(this.current_value)) : this.current_value})
    },
    generateCheckboxClass (field) {
      return [
        (field.required) ? "checkbox-danger" : "checkbox-primary"
      ]
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// client/components/Forms/Elements/Checkbox.vue